import { useQuery } from '@tanstack/react-query';
import { fetchBasicStatistics, type GraphFilters } from '../services/graphApi';

export function useBasicStatisticsQuery(eventId: number | null, filters?: GraphFilters) {
  return useQuery({
    queryKey: ['basic-statistics', eventId, filters],
    queryFn: () => fetchBasicStatistics(eventId ?? 0, filters),
    enabled: eventId != null,
  });
}
